import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import K from '../K'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    savedAt: new Date(),
    savedCb: null,
    byISO: {},
    updatedAt: null
  },
  getters: {
    getResponse: state => ({iso, question}) => {
      // console.log('GET', iso, question)
      if (!state.byISO[iso]) {
        return ''
      } else if (!state.byISO[iso][question]) {
        return ''
      } else {
        return state.byISO[iso][question]
      }
    },

    canGoNext: state => ({iso, question}) => {
      if (!state.updatedAt) {
        return false
      } else if (!state.byISO[iso]) {
        return false
      } else if (!state.byISO[iso][question]) {
        return false
      } else {
        // console.log(state.byISO[iso][question])
        return true
      }
    }
  },
  actions: {
    setResponse({state, dispatch}, {iso, question, response}) {
      // console.log('SET', iso, question, response)
      state.updatedAt = new Date()
      state.byISO[iso] = state.byISO[iso] || {}
      state.byISO[iso][question] = response

      localStorage.setItem(K.projectClient, JSON.stringify(state.byISO))

      dispatch('saveResponse')
    },

    getForm({state}, iso) {
      const form = state.byISO[iso] || {}
      form.host = window.location.hostname

      return form
    },

    saveResponse ({state, dispatch}) {
      const delta = (new Date()) - state.savedAt
      if (delta < 5000) {
        clearTimeout(state.savedCb)
        state.savedCb = setTimeout(() => {
          dispatch('saveResponse')
        }, 1000)
        return
      }

      clearTimeout(state.savedCb)

      const cur = localStorage.getItem(K.projectCurrent)
      const raw = localStorage.getItem(K.projectClient)
      let cli = {}
      try { cli = JSON.parse(raw) } catch (e) { console.log(e) }
      state.savedAt = new Date()
      
      axios.post('/sky/web/project/wip', {
        project: cli,
        current: cur,
        productId: localStorage.getItem(K.projectProductId),
        uid: localStorage.getItem(K.userId),
        raw: raw
      })
      .then(function () {
        // console.log(response)
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}